<template>
  <div class="modal fade" :id="`modal-notification-response-${notification.notification.id}`" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <h3>{{ notification.notification.title }}</h3>
          <p>{{ notification.notification.content }}</p>
          <button
            v-for="response in notification.notification.responses"
            :key="response.id"
            :ref="`response-button-${response.id}`"
            type="button"
            class="btn btn-block btn-dark"
            data-dismiss="modal"
            @click="handleRespondToNotificationCallback(response.id)">
            {{ response.button_label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { notify } from 'utils'
export default {
  props: {
    notification: {
      required: true,
      type: Object
    }
  },
  methods: {
    ...mapActions('notifications', ['respondToNotification']),
    handleRespondToNotificationCallback (responseId) {
      this.respondToNotification({ userId: this.$user.id, responseId, notificationId: this.notification.notification.id }).then(() => {
        notify.success('Response recorded')
      })
    }
  }
}
</script>
